module.exports = __webpack_public_path__ + "media/bootstrap-icons/music-note-ac797e83.svg";